export default "__VITE_ASSET__BAKmldSF__"